import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {CommandService} from "@core/services/command.service";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {catchError, filter, map, mergeMap, switchMap, take} from "rxjs/operators";
import {
  GET_ANALYTIC_REPORT_DETAILS,
  GET_DAC6_ANALYTIC_REPORT_DETAILS,
  GET_DASHBOARD_REPORT_DETAILS,
  GetAnalyticReportDetails,
  GetAnalyticReportDetailsFail,
  GetAnalyticReportDetailsSuccess,
  GetDac6AnalyticReportDetails,
  GetDac6AnalyticReportDetailsFail,
  GetDac6AnalyticReportDetailsSuccess,
  GetDashboardReportDetails,
  GetDashboardReportDetailsFail,
  GetDashboardReportDetailsSuccess,
  RESET_ANALYTIC_REPORT, RESET_DAC6_ANALYTIC_REPORT,
  ResetAnalyticsReport,
  ResetAnalyticsReportError,
  ResetAnalyticsReportSuccess, ResetDac6AnalyticsReportError, ResetDac6AnalyticsReportSuccess
} from "../action/dashboard-actions";
import {of, Observable} from "rxjs";
import {select, Store} from "@ngrx/store";
import {getCurrentProject, ProjectState} from "../../../projects/store/reducers/projects.reducer";
import {IPowerSearchState} from "../reducer/power-search.reducer";
import {
  GET_POWER_SEARCH_ANALYTIC_REPORT, GetPowerSearchAnalyticReportAction, GetPowerSearchAnalyticReportFailAction,
  GetPowerSearchAnalyticReportSuccessAction,
  SetReportProjectId
} from "../action/power-search-actions";
import {IDashboardState} from "../reducer/dashboard-reducer";
import {VisualizerNotificationService} from "../../Services/visualizer-notification.service";
import {VisualizerEmbedReport} from "../../models/power-search.model";
@Injectable()
export class DashbordEffects {

  GetDashboardReport = createEffect(() => this.actions$
    .pipe(
      ofType(GET_DASHBOARD_REPORT_DETAILS),
      mergeMap((action: GetDashboardReportDetails) => {
        let subscription = this.visualizerNotificationService.subscribeToEvent(action.command).pipe(
          map(
            response => {
              //this.fuseSplashScreenService.hide();
              return new GetDashboardReportDetailsSuccess(new VisualizerEmbedReport(response.payload));
            }
          ),
          catchError(error => {
            //this.fuseSplashScreenService.hide();
            return of(new GetDashboardReportDetailsFail(error));
          })
        );
        this.commandService.executeCommand(action.command);
        return subscription;
      })
    ));

  RefreshAnalyticsReport = createEffect(() => this.actions$
    .pipe(
      ofType(RESET_ANALYTIC_REPORT),
      mergeMap((action: ResetAnalyticsReport)=>{
        let subscription = this.visualizerNotificationService.subscribeToEvent(action.command).pipe(
          map(
            response => {
              return new ResetAnalyticsReportSuccess(response.payload);
            }
          ), catchError(error=>{
            return of(new ResetAnalyticsReportError(error))
          })
        );
        this.commandService.executeCommand(action.command);
        return subscription;
      })
    ));

  GetAnalyticdReport = createEffect(() => this.actions$
    .pipe(
      ofType(GET_ANALYTIC_REPORT_DETAILS),
      mergeMap((action: GetAnalyticReportDetails) => {
        //this.fuseSplashScreenService.show();
        let subscription = this.visualizerNotificationService.subscribeToEvent(action.command).pipe(
          map(
            (response: any) => {
              //this.fuseSplashScreenService.hide();
              return new GetAnalyticReportDetailsSuccess(new VisualizerEmbedReport(response.payload));
            }
          ),
          catchError(error => {
            //this.fuseSplashScreenService.hide();
            return of(new GetAnalyticReportDetailsFail(error));
          })
        );
        this.commandService.executeCommand(action.command);
        return subscription;
      })
    ));
  //Dac6

  GetDac6AnalyticdReport = createEffect(() => this.actions$
    .pipe(
      ofType(GET_DAC6_ANALYTIC_REPORT_DETAILS),
      mergeMap((action: GetDac6AnalyticReportDetails) => {
        //this.fuseSplashScreenService.show();
        let subscription = this.visualizerNotificationService.subscribeToEvent(action.command).pipe(
          map(
            (response: any) => {
              //this.fuseSplashScreenService.hide();
              return new GetDac6AnalyticReportDetailsSuccess(new VisualizerEmbedReport(response.payload));
            }
          ),
          catchError(error => {
            //this.fuseSplashScreenService.hide();
            return of(new GetDac6AnalyticReportDetailsFail(error));
          })
        );
        this.commandService.executeCommand(action.command)
        return subscription;
      })
    ));

  GetPowerSearchAnalyticReport = createEffect(() => this.actions$
    .pipe(
      ofType(GET_POWER_SEARCH_ANALYTIC_REPORT),
      mergeMap((action: GetPowerSearchAnalyticReportAction) => {
        //this.fuseSplashScreenService.show();
        let subscription = this.visualizerNotificationService.subscribeToEvent(action.command).pipe(
          map(
            (response: any) => {
              return new GetPowerSearchAnalyticReportSuccessAction(new VisualizerEmbedReport(response.payload));
            }
          ),
          catchError(error => {
            //this.fuseSplashScreenService.hide();
            return of(new GetPowerSearchAnalyticReportFailAction(error));
          })
        );
        this.commandService.executeCommand(action.command);
        return subscription;
      })
    ));

  ResetDac6AnalyticsReport = createEffect(() => this.actions$
    .pipe(
      ofType(RESET_DAC6_ANALYTIC_REPORT),
      mergeMap((action: ResetAnalyticsReport)=>{
        let subscription = this.visualizerNotificationService.subscribeToEvent(action.command).pipe(
          map(
            response => {
              return new ResetDac6AnalyticsReportSuccess(response.payload);
            }
          ), catchError(error=>{
            return of(new ResetDac6AnalyticsReportError(error))
          })
        );
        this.commandService.executeCommand(action.command);
        return subscription;
      })
    ));

  constructor(private actions$: Actions,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private powerSearchStore : Store<IPowerSearchState>,
              private visualizerNotificationService : VisualizerNotificationService) {
  }
}

